export type PictureAsset = {
  src: string;
  width: number;
  height: number;
  avif: string;
  webp: string;
  fallback: string;
};

function srcSet(name: string, widths: number[], extension: string) {
  return widths.map((width) => `/images/${name}-${width}.${extension} ${width}w`).join(", ");
}

function photo(
  name: string,
  widths: number[],
  width: number,
  height: number,
  fallbackWidth: number,
): PictureAsset {
  return {
    src: `/images/${name}-${fallbackWidth}.jpg`,
    width,
    height,
    avif: srcSet(name, widths, "avif"),
    webp: srcSet(name, widths, "webp"),
    fallback: `/images/${name}-${fallbackWidth}.jpg ${fallbackWidth}w`,
  };
}

export const heroImage = photo("hero-engine", [640, 1024, 1600], 1600, 1104, 1024);

export const clevorImage = photo("clevor-engine", [480, 768, 1024], 1024, 1536, 768);

export const shopSignImage = photo("champion-shop-sign", [320, 480], 480, 640, 480);

export const machinistImage = photo("about-machinist", [640, 960, 1200], 1200, 1200, 960);

export const ownerImage = photo("about-john-potts", [480, 800, 1200], 1200, 1600, 800);

const logoWidths = [96, 160, 240];

export const logoImage: PictureAsset = {
  src: "/images/champion-logo-160.png",
  width: 240,
  height: 240,
  avif: srcSet("champion-logo", logoWidths, "avif"),
  webp: srcSet("champion-logo", logoWidths, "webp"),
  fallback: srcSet("champion-logo", logoWidths, "png"),
};

export const imageSizes = {
  hero: "100vw",
  logoHeader: "(min-width: 640px) 56px, 48px",
  logoFooter: "48px",
  shopWide: "(min-width: 768px) 720px, 100vw",
  shopSide: "(min-width: 768px) 360px, 100vw",
  shopCard: "(min-width: 640px) 540px, 100vw",
  galleryFeatured: "(min-width: 1024px) 640px, 100vw",
  galleryThumb: "(min-width: 1024px) 420px, (min-width: 640px) 33vw, 100vw",
  portrait: "(min-width: 1024px) 560px, 100vw",
} as const;
